const phonePrefixes = [
  {
    label: 'France',
    value: '+33',
    isoCode: 'FR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/fr.svg'
  },
  {
    label: 'Spain',
    value: '+34',
    isoCode: 'ES',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/es.svg'
  },
  {
    label: 'Italy',
    value: '+39',
    isoCode: 'IT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/it.svg'
  },
  {
    label: 'Germany',
    value: '+49',
    isoCode: 'DE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/de.svg'
  },
  {
    label: 'Afghanistan',
    value: '+93',
    isoCode: 'AF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/af.svg'
  },
  {
    label: 'Aland Islands',
    value: '+358',
    isoCode: 'AX',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ax.svg'
  },
  {
    label: 'Albania',
    value: '+355',
    isoCode: 'AL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/al.svg'
  },
  {
    label: 'Algeria',
    value: '+213',
    isoCode: 'DZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/dz.svg'
  },
  {
    label: 'American Samoa',
    value: '+1684',
    isoCode: 'AS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/as.svg'
  },
  {
    label: 'Andorra',
    value: '+376',
    isoCode: 'AD',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ad.svg'
  },
  {
    label: 'Angola',
    value: '+244',
    isoCode: 'AO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ao.svg'
  },
  {
    label: 'Anguilla',
    value: '+1264',
    isoCode: 'AI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ai.svg'
  },
  {
    label: 'Antarctica',
    value: '+672',
    isoCode: 'AQ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/aq.svg'
  },
  {
    label: 'Antigua and Barbuda',
    value: '+1268',
    isoCode: 'AG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ag.svg'
  },
  {
    label: 'Argentina',
    value: '+54',
    isoCode: 'AR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ar.svg'
  },
  {
    label: 'Armenia',
    value: '+374',
    isoCode: 'AM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/am.svg'
  },
  {
    label: 'Aruba',
    value: '+297',
    isoCode: 'AW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/aw.svg'
  },
  {
    label: 'Ascension Island',
    value: '+247',
    isoCode: 'AC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ac.svg'
  },
  {
    label: 'Australia',
    value: '+61',
    isoCode: 'AU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/au.svg'
  },
  {
    label: 'Austria',
    value: '+43',
    isoCode: 'AT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/at.svg'
  },
  {
    label: 'Azerbaijan',
    value: '+994',
    isoCode: 'AZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/az.svg'
  },
  {
    label: 'Bahamas',
    value: '+1242',
    isoCode: 'BS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bs.svg'
  },
  {
    label: 'Bahrain',
    value: '+973',
    isoCode: 'BH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bh.svg'
  },
  {
    label: 'Bangladesh',
    value: '+880',
    isoCode: 'BD',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bd.svg'
  },
  {
    label: 'Barbados',
    value: '+1246',
    isoCode: 'BB',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bb.svg'
  },
  {
    label: 'Belarus',
    value: '+375',
    isoCode: 'BY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/by.svg'
  },
  {
    label: 'Belgium',
    value: '+32',
    isoCode: 'BE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/be.svg'
  },
  {
    label: 'Belize',
    value: '+501',
    isoCode: 'BZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bz.svg'
  },
  {
    label: 'Benin',
    value: '+229',
    isoCode: 'BJ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bj.svg'
  },
  {
    label: 'Bermuda',
    value: '+1441',
    isoCode: 'BM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bm.svg'
  },
  {
    label: 'Bhutan',
    value: '+975',
    isoCode: 'BT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bt.svg'
  },
  {
    label: 'Bolivia',
    value: '+591',
    isoCode: 'BO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bo.svg'
  },
  {
    label: 'Bosnia and Herzegovina',
    value: '+387',
    isoCode: 'BA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ba.svg'
  },
  {
    label: 'Botswana',
    value: '+267',
    isoCode: 'BW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bw.svg'
  },
  {
    label: 'Brazil',
    value: '+55',
    isoCode: 'BR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/br.svg'
  },
  {
    label: 'British Indian Ocean Territory',
    value: '+246',
    isoCode: 'IO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/io.svg'
  },
  {
    label: 'Brunei Darussalam',
    value: '+673',
    isoCode: 'BN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bn.svg'
  },
  {
    label: 'Bulgaria',
    value: '+359',
    isoCode: 'BG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bg.svg'
  },
  {
    label: 'Burkina Faso',
    value: '+226',
    isoCode: 'BF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bf.svg'
  },
  {
    label: 'Burundi',
    value: '+257',
    isoCode: 'BI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bi.svg'
  },
  {
    label: 'Cambodia',
    value: '+855',
    isoCode: 'KH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/kh.svg'
  },
  {
    label: 'Cameroon',
    value: '+237',
    isoCode: 'CM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cm.svg'
  },
  {
    label: 'Canada',
    value: '+1',
    isoCode: 'CA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ca.svg'
  },
  {
    label: 'Cape Verde',
    value: '+238',
    isoCode: 'CV',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cv.svg'
  },
  {
    label: 'Cayman Islands',
    value: '+1345',
    isoCode: 'KY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ky.svg'
  },
  {
    label: 'Central African Republic',
    value: '+236',
    isoCode: 'CF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cf.svg'
  },
  {
    label: 'Chad',
    value: '+235',
    isoCode: 'TD',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/td.svg'
  },
  {
    label: 'Chile',
    value: '+56',
    isoCode: 'CL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cl.svg'
  },
  {
    label: 'China',
    value: '+86',
    isoCode: 'CN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cn.svg'
  },
  {
    label: 'Christmas Island',
    value: '+61',
    isoCode: 'CX',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cx.svg'
  },
  {
    label: 'Cocos (Keeling) Islands',
    value: '+61',
    isoCode: 'CC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cc.svg'
  },
  {
    label: 'Colombia',
    value: '+57',
    isoCode: 'CO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/co.svg'
  },
  {
    label: 'Comoros',
    value: '+269',
    isoCode: 'KM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/km.svg'
  },
  {
    label: 'Congo',
    value: '+242',
    isoCode: 'CG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cg.svg'
  },
  {
    label: 'Cook Islands',
    value: '+682',
    isoCode: 'CK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ck.svg'
  },
  {
    label: 'Costa Rica',
    value: '+506',
    isoCode: 'CR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cr.svg'
  },
  {
    label: 'Croatia',
    value: '+385',
    isoCode: 'HR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/hr.svg'
  },
  {
    label: 'Cuba',
    value: '+53',
    isoCode: 'CU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cu.svg'
  },
  {
    label: 'Cyprus',
    value: '+357',
    isoCode: 'CY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cy.svg'
  },
  {
    label: 'Czech Republic',
    value: '+420',
    isoCode: 'CZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cz.svg'
  },
  {
    label: 'Democratic Republic of the Congo',
    value: '+243',
    isoCode: 'CD',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/cd.svg'
  },
  {
    label: 'Denmark',
    value: '+45',
    isoCode: 'DK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/dk.svg'
  },
  {
    label: 'Djibouti',
    value: '+253',
    isoCode: 'DJ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/dj.svg'
  },
  {
    label: 'Dominica',
    value: '+1767',
    isoCode: 'DM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/dm.svg'
  },
  {
    label: 'Dominican Republic',
    value: '+1849',
    isoCode: 'DO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/do.svg'
  },
  {
    label: 'Ecuador',
    value: '+593',
    isoCode: 'EC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ec.svg'
  },
  {
    label: 'Egypt',
    value: '+20',
    isoCode: 'EG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/eg.svg'
  },
  {
    label: 'El Salvador',
    value: '+503',
    isoCode: 'SV',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sv.svg'
  },
  {
    label: 'Equatorial Guinea',
    value: '+240',
    isoCode: 'GQ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gq.svg'
  },
  {
    label: 'Eritrea',
    value: '+291',
    isoCode: 'ER',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/er.svg'
  },
  {
    label: 'Estonia',
    value: '+372',
    isoCode: 'EE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ee.svg'
  },
  {
    label: 'Eswatini',
    value: '+268',
    isoCode: 'SZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sz.svg'
  },
  {
    label: 'Ethiopia',
    value: '+251',
    isoCode: 'ET',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/et.svg'
  },
  {
    label: 'Falkland Islands (Malvinas)',
    value: '+500',
    isoCode: 'FK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/fk.svg'
  },
  {
    label: 'Faroe Islands',
    value: '+298',
    isoCode: 'FO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/fo.svg'
  },
  {
    label: 'Fiji',
    value: '+679',
    isoCode: 'FJ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/fj.svg'
  },
  {
    label: 'Finland',
    value: '+358',
    isoCode: 'FI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/fi.svg'
  },

  {
    label: 'French Guiana',
    value: '+594',
    isoCode: 'GF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gf.svg'
  },
  {
    label: 'French Polynesia',
    value: '+689',
    isoCode: 'PF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pf.svg'
  },
  {
    label: 'Gabon',
    value: '+241',
    isoCode: 'GA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ga.svg'
  },
  {
    label: 'Gambia',
    value: '+220',
    isoCode: 'GM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gm.svg'
  },
  {
    label: 'Georgia',
    value: '+995',
    isoCode: 'GE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ge.svg'
  },

  {
    label: 'Ghana',
    value: '+233',
    isoCode: 'GH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gh.svg'
  },
  {
    label: 'Gibraltar',
    value: '+350',
    isoCode: 'GI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gi.svg'
  },
  {
    label: 'Greece',
    value: '+30',
    isoCode: 'GR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gr.svg'
  },
  {
    label: 'Greenland',
    value: '+299',
    isoCode: 'GL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gl.svg'
  },
  {
    label: 'Grenada',
    value: '+1473',
    isoCode: 'GD',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gd.svg'
  },
  {
    label: 'Guadeloupe',
    value: '+590',
    isoCode: 'GP',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gp.svg'
  },
  {
    label: 'Guam',
    value: '+1671',
    isoCode: 'GU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gu.svg'
  },
  {
    label: 'Guatemala',
    value: '+502',
    isoCode: 'GT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gt.svg'
  },
  {
    label: 'Guernsey',
    value: '+44',
    isoCode: 'GG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gg.svg'
  },
  {
    label: 'Guinea',
    value: '+224',
    isoCode: 'GN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gn.svg'
  },
  {
    label: 'Guinea-Bissau',
    value: '+245',
    isoCode: 'GW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gw.svg'
  },
  {
    label: 'Guyana',
    value: '+592',
    isoCode: 'GY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gy.svg'
  },
  {
    label: 'Haiti',
    value: '+509',
    isoCode: 'HT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ht.svg'
  },
  {
    label: 'Holy See (Vatican City State)',
    value: '+379',
    isoCode: 'VA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/va.svg'
  },
  {
    label: 'Honduras',
    value: '+504',
    isoCode: 'HN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/hn.svg'
  },
  {
    label: 'Hong Kong',
    value: '+852',
    isoCode: 'HK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/hk.svg'
  },
  {
    label: 'Hungary',
    value: '+36',
    isoCode: 'HU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/hu.svg'
  },
  {
    label: 'Iceland',
    value: '+354',
    isoCode: 'IS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/is.svg'
  },
  {
    label: 'India',
    value: '+91',
    isoCode: 'IN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/in.svg'
  },
  {
    label: 'Indonesia',
    value: '+62',
    isoCode: 'ID',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/id.svg'
  },
  {
    label: 'Iran',
    value: '+98',
    isoCode: 'IR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ir.svg'
  },
  {
    label: 'Iraq',
    value: '+964',
    isoCode: 'IQ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/iq.svg'
  },
  {
    label: 'Ireland',
    value: '+353',
    isoCode: 'IE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ie.svg'
  },
  {
    label: 'Isle of Man',
    value: '+44',
    isoCode: 'IM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/im.svg'
  },
  {
    label: 'Israel',
    value: '+972',
    isoCode: 'IL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/il.svg'
  },

  {
    label: "Ivory Coast / Cote d'Ivoire",
    value: '+225',
    isoCode: 'CI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ci.svg'
  },
  {
    label: 'Jamaica',
    value: '+1876',
    isoCode: 'JM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/jm.svg'
  },
  {
    label: 'Japan',
    value: '+81',
    isoCode: 'JP',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/jp.svg'
  },
  {
    label: 'Jersey',
    value: '+44',
    isoCode: 'JE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/je.svg'
  },
  {
    label: 'Jordan',
    value: '+962',
    isoCode: 'JO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/jo.svg'
  },
  {
    label: 'Kazakhstan',
    value: '+77',
    isoCode: 'KZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/kz.svg'
  },
  {
    label: 'Kenya',
    value: '+254',
    isoCode: 'KE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ke.svg'
  },
  {
    label: 'Kiribati',
    value: '+686',
    isoCode: 'KI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ki.svg'
  },
  {
    label: "Korea, Democratic People's Republic of Korea",
    value: '+850',
    isoCode: 'KP',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/kp.svg'
  },
  {
    label: 'Korea, Republic of South Korea',
    value: '+82',
    isoCode: 'KR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/kr.svg'
  },
  {
    label: 'Kosovo',
    value: '+383',
    isoCode: 'XK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/xk.svg'
  },
  {
    label: 'Kuwait',
    value: '+965',
    isoCode: 'KW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/kw.svg'
  },
  {
    label: 'Kyrgyzstan',
    value: '+996',
    isoCode: 'KG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/kg.svg'
  },
  {
    label: 'Laos',
    value: '+856',
    isoCode: 'LA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/la.svg'
  },
  {
    label: 'Latvia',
    value: '+371',
    isoCode: 'LV',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/lv.svg'
  },
  {
    label: 'Lebanon',
    value: '+961',
    isoCode: 'LB',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/lb.svg'
  },
  {
    label: 'Lesotho',
    value: '+266',
    isoCode: 'LS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ls.svg'
  },
  {
    label: 'Liberia',
    value: '+231',
    isoCode: 'LR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/lr.svg'
  },
  {
    label: 'Libya',
    value: '+218',
    isoCode: 'LY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ly.svg'
  },
  {
    label: 'Liechtenstein',
    value: '+423',
    isoCode: 'LI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/li.svg'
  },
  {
    label: 'Lithuania',
    value: '+370',
    isoCode: 'LT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/lt.svg'
  },
  {
    label: 'Luxembourg',
    value: '+352',
    isoCode: 'LU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/lu.svg'
  },
  {
    label: 'Macau',
    value: '+853',
    isoCode: 'MO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mo.svg'
  },
  {
    label: 'Madagascar',
    value: '+261',
    isoCode: 'MG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mg.svg'
  },
  {
    label: 'Malawi',
    value: '+265',
    isoCode: 'MW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mw.svg'
  },
  {
    label: 'Malaysia',
    value: '+60',
    isoCode: 'MY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/my.svg'
  },
  {
    label: 'Maldives',
    value: '+960',
    isoCode: 'MV',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mv.svg'
  },
  {
    label: 'Mali',
    value: '+223',
    isoCode: 'ML',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ml.svg'
  },
  {
    label: 'Malta',
    value: '+356',
    isoCode: 'MT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mt.svg'
  },
  {
    label: 'Marshall Islands',
    value: '+692',
    isoCode: 'MH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mh.svg'
  },
  {
    label: 'Martinique',
    value: '+596',
    isoCode: 'MQ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mq.svg'
  },
  {
    label: 'Mauritania',
    value: '+222',
    isoCode: 'MR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mr.svg'
  },
  {
    label: 'Mauritius',
    value: '+230',
    isoCode: 'MU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mu.svg'
  },
  {
    label: 'Mayotte',
    value: '+262',
    isoCode: 'YT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/yt.svg'
  },
  {
    label: 'Mexico',
    value: '+52',
    isoCode: 'MX',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mx.svg'
  },
  {
    label: 'Micronesia, Federated States of Micronesia',
    value: '+691',
    isoCode: 'FM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/fm.svg'
  },
  {
    label: 'Moldova',
    value: '+373',
    isoCode: 'MD',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/md.svg'
  },
  {
    label: 'Monaco',
    value: '+377',
    isoCode: 'MC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mc.svg'
  },
  {
    label: 'Mongolia',
    value: '+976',
    isoCode: 'MN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mn.svg'
  },
  {
    label: 'Montenegro',
    value: '+382',
    isoCode: 'ME',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/me.svg'
  },
  {
    label: 'Montserrat',
    value: '+1664',
    isoCode: 'MS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ms.svg'
  },
  {
    label: 'Morocco',
    value: '+212',
    isoCode: 'MA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ma.svg'
  },
  {
    label: 'Mozambique',
    value: '+258',
    isoCode: 'MZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mz.svg'
  },
  {
    label: 'Myanmar',
    value: '+95',
    isoCode: 'MM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mm.svg'
  },
  {
    label: 'Namibia',
    value: '+264',
    isoCode: 'NA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/na.svg'
  },
  {
    label: 'Nauru',
    value: '+674',
    isoCode: 'NR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/nr.svg'
  },
  {
    label: 'Nepal',
    value: '+977',
    isoCode: 'NP',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/np.svg'
  },
  {
    label: 'Netherlands',
    value: '+31',
    isoCode: 'NL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/nl.svg'
  },
  {
    label: 'Netherlands Antilles',
    value: '+599',
    isoCode: 'AN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/an.svg'
  },
  {
    label: 'New Caledonia',
    value: '+687',
    isoCode: 'NC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/nc.svg'
  },
  {
    label: 'New Zealand',
    value: '+64',
    isoCode: 'NZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/nz.svg'
  },
  {
    label: 'Nicaragua',
    value: '+505',
    isoCode: 'NI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ni.svg'
  },
  {
    label: 'Niger',
    value: '+227',
    isoCode: 'NE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ne.svg'
  },
  {
    label: 'Nigeria',
    value: '+234',
    isoCode: 'NG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ng.svg'
  },
  {
    label: 'Niue',
    value: '+683',
    isoCode: 'NU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/nu.svg'
  },
  {
    label: 'Norfolk Island',
    value: '+672',
    isoCode: 'NF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/nf.svg'
  },
  {
    label: 'North Macedonia',
    value: '+389',
    isoCode: 'MK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mk.svg'
  },
  {
    label: 'Northern Mariana Islands',
    value: '+1670',
    isoCode: 'MP',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mp.svg'
  },
  {
    label: 'Norway',
    value: '+47',
    isoCode: 'NO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/no.svg'
  },
  {
    label: 'Oman',
    value: '+968',
    isoCode: 'OM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/om.svg'
  },
  {
    label: 'Pakistan',
    value: '+92',
    isoCode: 'PK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pk.svg'
  },
  {
    label: 'Palau',
    value: '+680',
    isoCode: 'PW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pw.svg'
  },
  {
    label: 'Palestine',
    value: '+970',
    isoCode: 'PS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ps.svg'
  },
  {
    label: 'Panama',
    value: '+507',
    isoCode: 'PA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pa.svg'
  },
  {
    label: 'Papua New Guinea',
    value: '+675',
    isoCode: 'PG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pg.svg'
  },
  {
    label: 'Paraguay',
    value: '+595',
    isoCode: 'PY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/py.svg'
  },
  {
    label: 'Peru',
    value: '+51',
    isoCode: 'PE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pe.svg'
  },
  {
    label: 'Philippines',
    value: '+63',
    isoCode: 'PH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ph.svg'
  },
  {
    label: 'Pitcairn',
    value: '+872',
    isoCode: 'PN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pn.svg'
  },
  {
    label: 'Poland',
    value: '+48',
    isoCode: 'PL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pl.svg'
  },
  {
    label: 'Portugal',
    value: '+351',
    isoCode: 'PT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pt.svg'
  },
  {
    label: 'Puerto Rico',
    value: '+1939',
    isoCode: 'PR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pr.svg'
  },
  {
    label: 'Qatar',
    value: '+974',
    isoCode: 'QA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/qa.svg'
  },
  {
    label: 'Reunion',
    value: '+262',
    isoCode: 'RE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/re.svg'
  },
  {
    label: 'Romania',
    value: '+40',
    isoCode: 'RO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ro.svg'
  },
  {
    label: 'Russia',
    value: '+7',
    isoCode: 'RU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ru.svg'
  },
  {
    label: 'Rwanda',
    value: '+250',
    isoCode: 'RW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/rw.svg'
  },
  {
    label: 'Saint Barthelemy',
    value: '+590',
    isoCode: 'BL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/bl.svg'
  },
  {
    label: 'Saint Helena, Ascension and Tristan Da Cunha',
    value: '+290',
    isoCode: 'SH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sh.svg'
  },
  {
    label: 'Saint Kitts and Nevis',
    value: '+1869',
    isoCode: 'KN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/kn.svg'
  },
  {
    label: 'Saint Lucia',
    value: '+1758',
    isoCode: 'LC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/lc.svg'
  },
  {
    label: 'Saint Martin',
    value: '+590',
    isoCode: 'MF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/mf.svg'
  },
  {
    label: 'Saint Pierre and Miquelon',
    value: '+508',
    isoCode: 'PM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/pm.svg'
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: '+1784',
    isoCode: 'VC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/vc.svg'
  },
  {
    label: 'Samoa',
    value: '+685',
    isoCode: 'WS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ws.svg'
  },
  {
    label: 'San Marino',
    value: '+378',
    isoCode: 'SM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sm.svg'
  },
  {
    label: 'Sao Tome and Principe',
    value: '+239',
    isoCode: 'ST',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/st.svg'
  },
  {
    label: 'Saudi Arabia',
    value: '+966',
    isoCode: 'SA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sa.svg'
  },
  {
    label: 'Senegal',
    value: '+221',
    isoCode: 'SN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sn.svg'
  },
  {
    label: 'Serbia',
    value: '+381',
    isoCode: 'RS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/rs.svg'
  },
  {
    label: 'Seychelles',
    value: '+248',
    isoCode: 'SC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sc.svg'
  },
  {
    label: 'Sierra Leone',
    value: '+232',
    isoCode: 'SL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sl.svg'
  },
  {
    label: 'Singapore',
    value: '+65',
    isoCode: 'SG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sg.svg'
  },
  {
    label: 'Sint Maarten',
    value: '+1721',
    isoCode: 'SX',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sx.svg'
  },
  {
    label: 'Slovakia',
    value: '+421',
    isoCode: 'SK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sk.svg'
  },
  {
    label: 'Slovenia',
    value: '+386',
    isoCode: 'SI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/si.svg'
  },
  {
    label: 'Solomon Islands',
    value: '+677',
    isoCode: 'SB',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sb.svg'
  },
  {
    label: 'Somalia',
    value: '+252',
    isoCode: 'SO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/so.svg'
  },
  {
    label: 'South Africa',
    value: '+27',
    isoCode: 'ZA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/za.svg'
  },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: '+500',
    isoCode: 'GS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gs.svg'
  },
  {
    label: 'South Sudan',
    value: '+211',
    isoCode: 'SS',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ss.svg'
  },

  {
    label: 'Sri Lanka',
    value: '+94',
    isoCode: 'LK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/lk.svg'
  },
  {
    label: 'Sudan',
    value: '+249',
    isoCode: 'SD',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sd.svg'
  },
  {
    label: 'Surilabel',
    value: '+597',
    isoCode: 'SR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sr.svg'
  },
  {
    label: 'Svalbard and Jan Mayen',
    value: '+47',
    isoCode: 'SJ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sj.svg'
  },
  {
    label: 'Sweden',
    value: '+46',
    isoCode: 'SE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/se.svg'
  },
  {
    label: 'Switzerland',
    value: '+41',
    isoCode: 'CH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ch.svg'
  },
  {
    label: 'Syrian Arab Republic',
    value: '+963',
    isoCode: 'SY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/sy.svg'
  },
  {
    label: 'Taiwan',
    value: '+886',
    isoCode: 'TW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tw.svg'
  },
  {
    label: 'Tajikistan',
    value: '+992',
    isoCode: 'TJ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tj.svg'
  },
  {
    label: 'Tanzania, United Republic of Tanzania',
    value: '+255',
    isoCode: 'TZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tz.svg'
  },
  {
    label: 'Thailand',
    value: '+66',
    isoCode: 'TH',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/th.svg'
  },
  {
    label: 'Timor-Leste',
    value: '+670',
    isoCode: 'TL',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tl.svg'
  },
  {
    label: 'Togo',
    value: '+228',
    isoCode: 'TG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tg.svg'
  },
  {
    label: 'Tokelau',
    value: '+690',
    isoCode: 'TK',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tk.svg'
  },
  {
    label: 'Tonga',
    value: '+676',
    isoCode: 'TO',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/to.svg'
  },
  {
    label: 'Trinidad and Tobago',
    value: '+1868',
    isoCode: 'TT',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tt.svg'
  },
  {
    label: 'Tunisia',
    value: '+216',
    isoCode: 'TN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tn.svg'
  },
  {
    label: 'Turkey',
    value: '+90',
    isoCode: 'TR',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tr.svg'
  },
  {
    label: 'Turkmenistan',
    value: '+993',
    isoCode: 'TM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tm.svg'
  },
  {
    label: 'Turks and Caicos Islands',
    value: '+1649',
    isoCode: 'TC',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tc.svg'
  },
  {
    label: 'Tuvalu',
    value: '+688',
    isoCode: 'TV',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/tv.svg'
  },
  {
    label: 'Uganda',
    value: '+256',
    isoCode: 'UG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ug.svg'
  },
  {
    label: 'Ukraine',
    value: '+380',
    isoCode: 'UA',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ua.svg'
  },
  {
    label: 'United Arab Emirates',
    value: '+971',
    isoCode: 'AE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ae.svg'
  },
  {
    label: 'United Kingdom',
    value: '+44',
    isoCode: 'GB',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/gb.svg'
  },
  {
    label: 'United States',
    value: '+1',
    isoCode: 'US',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/us.svg'
  },
  {
    label: 'United States Minor Outlying Islands',
    value: '+246',
    isoCode: 'UMI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/umi.svg'
  },
  {
    label: 'Uruguay',
    value: '+598',
    isoCode: 'UY',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/uy.svg'
  },
  {
    label: 'Uzbekistan',
    value: '+998',
    isoCode: 'UZ',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/uz.svg'
  },
  {
    label: 'Vanuatu',
    value: '+678',
    isoCode: 'VU',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/vu.svg'
  },
  {
    label: 'Venezuela, Bolivarian Republic of Venezuela',
    value: '+58',
    isoCode: 'VE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ve.svg'
  },
  {
    label: 'Vietnam',
    value: '+84',
    isoCode: 'VN',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/vn.svg'
  },
  {
    label: 'Virgin Islands, British',
    value: '+1284',
    isoCode: 'VG',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/vg.svg'
  },
  {
    label: 'Virgin Islands, U.S.',
    value: '+1340',
    isoCode: 'VI',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/vi.svg'
  },
  {
    label: 'Wallis and Futuna',
    value: '+681',
    isoCode: 'WF',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/wf.svg'
  },
  {
    label: 'Yemen',
    value: '+967',
    isoCode: 'YE',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/ye.svg'
  },
  {
    label: 'Zambia',
    value: '+260',
    isoCode: 'ZM',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/zm.svg'
  },
  {
    label: 'Zimbabwe',
    value: '+263',
    isoCode: 'ZW',
    flag: 'https://cdn.kcak11.com/CountryFlags/countries/zw.svg'
  }
];

export default phonePrefixes;
